const dialog = {
  "demo.trial.dialog.title": "Has desbloqueado la prueba de BYB",
  "demo.trial.dialog.description":
    "La prueba es tu línea de partida. Obtén la aplicación de VR y da el primer paso para pensar más rápido, ver más claro y jugar más inteligente.",
  "demo.trial.dialog.vr.cta": "Obtén la aplicación de VR",
  "demo.trial.dialog.converting.description": "Configurando tu acceso a la prueba",
  "demo.creating.account.dialog.title": "Configurando tu cuenta",
  "demo.creating.account.dialog.description": "Estamos creando tu cuenta y preparando tu experiencia de prueba. Esto solo tomará un momento.",
};

const signIn = {
  "demo.signin.convert.title": "Inicia sesión y comienza tu prueba de 2 días",
  "demo.signin.convert.button": "Comenzar prueba",
};

export const demo = {
  ...dialog,
  ...signIn,
};

